import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';




import { Navigation,Autoplay,Pagination} from 'swiper/modules';


import { testimonialData } from '../Data/data';
const Testimonial = () => {
  return (
    <>
   {/* <Heading heading={"Testimonial"} height={"100px"} text={"4xl"} /> */}
   <div className={`h-[250px] flex items-center justify-center`}>
    <div className='max-w-md mx-auto  w-full'>
    <h2 className="flex flex-row flex-nowrap items-center my-8">
        <span className="flex-grow block border-t border-[#07c991a8]" aria-hidden="true" role="presentation"></span>
        <span className={`flex-none block px-4 py-2.5  text-3xl font-semibold max-md:text-xl leading-none  uppercase text-[#07c991a8]`}>
           Testimonial
        </span>
        <span className="flex-grow block border-t  border-[#07c991a8]" aria-hidden="true" role="presentation"></span>
    </h2>
    </div>
    </div>
    <Swiper 
    // navigation={true}
    autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
     modules={[Autoplay,Navigation,Pagination]} className="mySwiper"
    >
    {
      testimonialData?.map((item, index)=>{
        return(
          <SwiperSlide key={index}>
    <section className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:px-8 -mt-20">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.indigo.100),white)] opacity-20" />
      <div className="absolute inset-y-0 right-1/2 -z-10 mr-16 w-[200%] origin-bottom-left skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 sm:mr-28 lg:mr-0 xl:mr-16 xl:origin-center" />
      <div className="mx-auto max-w-2xl lg:max-w-4xl">
      <img
              className="mx-auto h-20 w-20 rounded-full object-cover"
              src={item?.img}
              alt=""
            />
        <figure className="mt-10">
          <blockquote className="text-center text-md  leading-8 max-sm:text-sm sm:leading-9">
            <p>
            {item?.desc}
            </p>
          </blockquote>
          <figcaption className="mt-10">
           
            <div className="mt-4 flex items-center justify-center space-x-3 text-xl max-sm:text-md">
              <div className="font-semibold text-gray-900">{item?.name}</div>
              <svg viewBox="0 0 2 2" width={3} height={3} aria-hidden="true" className="fill-gray-900">
                {/* <circle cx={1} cy={1} r={1} /> */}
              </svg>
              {/* <div className="text-gray-600">CEO of Workcation</div> */}
            </div>
          </figcaption>
        </figure>
      </div>
    </section>
    </SwiperSlide>
        )
      })
    }
   
  </Swiper>

  </>
  );
};

export default Testimonial;